module.exports = "<div class=\"content-wrapper\">\n  <div class=\"container-fluid\">\n    <p>\n      In development!\n    </p>\n  </div>\n</div>\n"